import { getAcademicYearByDate } from './getAcademicYearByDate';

export const getAcademicYearsByPeriod = (startDate: Date, endDate: Date) => {
  const startDateAcademicYear = getAcademicYearByDate(startDate);
  const endDateAcademicYear = getAcademicYearByDate(endDate);

  const minYear = startDateAcademicYear.split('-')[0];
  const maxYear = endDateAcademicYear.split('-')[1];

  const academicYears: string[] = [];

  for (let year = Number(minYear); year < Number(maxYear); year++) {
    academicYears.push(`${year}-${year + 1}`);
  }

  return academicYears;
};
